"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const simulateGetLogs_js_1 = __importDefault(require("./simulateGetLogs.js"));
const eventsApiGetLogs_js_1 = __importDefault(require("./eventsApiGetLogs.js"));
const logsApiGetLogs_js_1 = __importDefault(require("./logsApiGetLogs.js"));
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default("java-tron-provider:warning");
function eth_getLogs([filterObject], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        // fastest... available through logs.opentron.org
        if (ctx.tronLogsClient) {
            return logsApiGetLogs_js_1.default([filterObject], ctx);
        }
        if (ctx.tronEventsClient) {
            return eventsApiGetLogs_js_1.default([filterObject], ctx);
        }
        debug("unknown events API URL, eth_getLogs using slow method");
        // this is a really slow method... not usable for mainnet
        return simulateGetLogs_js_1.default([filterObject], ctx);
    });
}
exports.default = eth_getLogs;
